import React from 'react'
import './footer.css'

function Footer() {
    return (
        <div className='footer'>
            Created By Nadun Dilshan |  2022 All rights reserved.
        </div>
    )
}

export default Footer
